import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { AdditionalEmail as AdditionalEmailType } from './types';

interface Props {
  additionalEmail: AdditionalEmailType;
  onChange: (additionalEmail: AdditionalEmailType) => void;
  onDelete: (additionalEmail: AdditionalEmailType) => void;
}

export default function AdditionalEmails({ additionalEmail, onChange, onDelete }: Props) {
  return (
    <div className="d-flex align-items-center">
      <div className="flex-fill">
        <ManagedFormGroup
          autoComplete="off"
          className="mb-0"
          label="Additional Email"
          name="email"
          placeholder="Type email"
          value={additionalEmail.email || ''}
          onValueChange={email => onChange({ ...additionalEmail, email })}
        />
      </div>

      <FontAwesomeIcon
        className="clickable ms-3"
        icon={faTrashAlt}
        onClick={() => onDelete(additionalEmail)}
      />
    </div>
  );
}
